(function () {
  'use strict';

  // ---- Demo interactiva de tono/brillo ----
  class ChLightDemo extends HTMLElement {
    connectedCallback() {
      this.glow = this.querySelector('[data-glow]');
      this.toneButtons = this.querySelectorAll('[data-tone]');
      this.slider = this.querySelector('[data-brightness]');
      this.brightnessValue = this.querySelector('[data-brightness-value]');

      this.toneButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.setTone(btn));
      });

      if (this.slider) {
        this.slider.addEventListener('input', () => this.updateGlow());
      }

      this.updateGlow();
    }

    setTone(activeBtn) {
      this.toneButtons.forEach((btn) => btn.classList.remove('is-active'));
      activeBtn.classList.add('is-active');
      this.updateGlow();
    }

    updateGlow() {
      if (!this.glow) return;
      const activeBtn = this.querySelector('.ch-tone-btn.is-active') || this.toneButtons[0];
      const color = activeBtn ? activeBtn.dataset.color : '#fff2d6';
      const brightness = this.slider ? Number(this.slider.value) : 70;

      this.glow.style.background =
        'radial-gradient(ellipse at center, ' + color + ' 0%, ' + color + '33 45%, transparent 70%)';
      this.glow.style.opacity = (brightness / 100).toFixed(2);

      if (this.brightnessValue) {
        this.brightnessValue.textContent = brightness + '%';
      }
    }
  }

  if (!customElements.get('ch-light-demo')) {
    customElements.define('ch-light-demo', ChLightDemo);
  }

  // ---- Botón Comprar Ahora / Buy Now (agrega al carrito y redirige a checkout) ----
  class ChBuyNow extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => this.handleClick(e));
    }

    async handleClick(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.innerHTML;
      this.classList.add('is-loading');
      this.innerHTML = 'Agregando…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (!response.ok) throw new Error('No se pudo agregar al carrito');

        window.location.href = '/checkout';
      } catch (err) {
        this.innerHTML = originalText;
        this.classList.remove('is-loading');
        window.location.href = '/cart';
      }
    }
  }

    if (!customElements.get('ch-buy-now')) {
    customElements.define('ch-buy-now', ChBuyNow);
  }

  // ---- Formulario "Dejá tu reseña" (solo visual, no guarda datos) ----
  class ChReviewForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-review-form]');
      this.thanks = this.querySelector('[data-review-thanks]');
      this.starButtons = this.querySelectorAll('[data-star]');
      this.selectedStars = 0;

      this.starButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.setStars(Number(btn.dataset.star)));
      });

      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      }
    }

    setStars(value) {
      this.selectedStars = value;
      this.starButtons.forEach((btn) => {
        btn.classList.toggle('is-filled', Number(btn.dataset.star) <= value);
      });
    }

    handleSubmit(e) {
      e.preventDefault();
      if (this.form) this.form.hidden = true;
      if (this.thanks) this.thanks.hidden = false;
    }
  }

  if (!customElements.get('ch-review-form')) {
    customElements.define('ch-review-form', ChReviewForm);
  }
})();